function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30 16c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14Zm-12.037 5.732a1.8 1.8 0 1 0-3.6 0 1.8 1.8 0 0 0 3.6 0Zm-3.674-9.447a1.757 1.757 0 1 1 2.795 1.78c-.438.344-1 .801-1.452 1.356-.456.561-.882 1.323-.882 2.268v.343c0 .22.18.4.4.4h1.7a.4.4 0 0 0 .4-.4v-.343c0-.16.068-.378.322-.69.26-.32.625-.63 1.056-.968a4.256 4.256 0 1 0-6.866-3.748c-.02.22.16.4.382.4h1.7c.22 0 .395-.182.445-.398Z"
  }));
};
var componentName = 'QuestionFilled';
export var QuestionFilled = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
QuestionFilled.displayName = componentName;